import React from 'react'

import { Label } from '@rebass/forms'
import { useSTheme } from 'styles/theme'
import { fontSize } from '../constants'
import { SxStyleProp } from 'rebass'

type Props = {
    color?: string
    for?: string
    children: any
    sx?: SxStyleProp
}

const FLabel = React.forwardRef((props: Props, ref) => {
    const { sx, color, children } = props
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    return (
        <Label
            sx={{
                mb: 2,
                color: color,
                fontFamily: fontFamily,
                fontWeight: '500',
                fontSize: fontSize.label.desktop,
                ...sx,
            }}
            htmlFor={props.for}
            ref={ref}
            dangerouslySetInnerHTML={{ __html: children }}
        />
    )
})

FLabel.displayName = 'FLabel'

export default FLabel
